import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: 'pocketlab',
    loadChildren: () =>
      import('./components/data-view/data-view.module').then(
        (m) => m.DataViewModule,
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./components/cloudlab-auth/cloudlab-auth.module').then(
        (m) => m.CloudlabAuthModule,
      ),
  },
  {path: 'student', redirectTo: 'auth/class-code', pathMatch: 'full'},
  {path: 'teacher', redirectTo: 'auth/sign-in', pathMatch: 'full'},
  {
    path: 'nar',
    loadChildren: () =>
      import('./components/nar/nar.module').then((m) => m.NarModule),
  },
  {
    path: 'demo/:containerId',
    redirectTo: 'auth/register-temp-user/:containerId',
    pathMatch: 'full',
  },
  {
    path: 'kesler-demo/submission',
    redirectTo: 'curriculum-demo-auto-add/kesler-demo',
    pathMatch: 'full',
  },
  {
    path: 'curriculum-demo-auto-add/:containerId',
    loadChildren: () =>
      import('./components/curriculum-demo-auto-add/curriculum-demo-auto-add.module').then(
        (m) => m.CurriculumDemoAutoAddModule,
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./components/navigation/navigation-container/navigation-container.routing').then(
        (m) => m.routes,
      ),
  },
];
